/** The words the family sees on the report (skill 13 — no ledger vocabulary). */
import type { StabilityClass } from '@pfo/analytics';

// Re-exported rather than restated: the expense form offers these words as choices and the
// report reads them back, so a second copy is a second answer waiting to disagree.
export { PLANNING_NATURE_LABELS } from '../../transactions/model/transactionLabels.js';

export const STABILITY_LABELS: Record<StabilityClass, string> = {
  stable: 'Ổn định hằng tháng',
  semi_stable: 'Tương đối ổn định',
  variable: 'Thay đổi thất thường',
  one_off: 'Một lần',
};

/** Which stability classes count as money the household can plan around (B10). */
export function isStable(stabilityClass: StabilityClass): boolean {
  return stabilityClass === 'stable' || stabilityClass === 'semi_stable';
}

const MONTH_LABEL = new Intl.DateTimeFormat('vi-VN', {
  month: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
});

/** "Tháng 8/2026" from a YYYY-MM-DD first-of-month key. */
export function monthLabel(periodStart: string): string {
  return `Tháng ${MONTH_LABEL.format(new Date(`${periodStart}T00:00:00Z`))}`;
}
